// extracted by mini-css-extract-plugin
export default {"label":"AutocompleteField_label__QgZ9+","labelText":"AutocompleteField_labelText__oV5ID","inputGroup":"AutocompleteField_inputGroup__MbFKJ"};